import React from "react";

const Message = ({ message }) => {
  return <div>{message.text}</div>;
};

export default Message;
